"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var containers_1 = require("./containers");
/** ConcurrencyLimit simplifies the task of running a large number
 * asynchronous computations. Given a function that when invoked will e.g.
 * perform some io and produce a promise of `V`, we queue and run them
 * with some fixed maximum concurrency. This is useful for limiting the
 * number of open files, number of concurrent network operations, or
 * heap space.
 */
var ConcurrencyLimit = /** @class */ (function () {
    function ConcurrencyLimit(concurrency) {
        this.concurrency = concurrency;
        this.active = 0;
        this.queue = new containers_1.DeQueue();
        this.queued = 0;
        this.complete = 0;
        this.errors = 0;
        this.callbacks = [];
    }
    /** Run an asynchronous computation
     */
    ConcurrencyLimit.prototype.run = function (f) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            _this.queue.pushBack(function () {
                _this.active++;
                return f()
                    .then(function (r) {
                    _this.finished();
                    resolve(r);
                })
                    .catch(function (e) {
                    _this.finished();
                    reject(e);
                });
            });
            _this.queued++;
        });
        this.schedule();
        return promise;
    };
    /** Start receiving progress reports from the controller.
     * @param cb the function to be invoked once each time a result
     * is produced.
     */
    ConcurrencyLimit.prototype.onProgress = function (cb) {
        this.callbacks.push(cb);
    };
    ConcurrencyLimit.prototype.finished = function () {
        this.active--;
        this.complete++;
        this.schedule();
        this.postProgress();
    };
    ConcurrencyLimit.prototype.schedule = function () {
        if (this.active < this.concurrency) {
            var job = this.queue.popFront();
            if (typeof job !== 'undefined') {
                job();
            }
        }
    };
    ConcurrencyLimit.prototype.postProgress = function () {
        var progress = { queued: this.queued, active: this.active, complete: this.complete, errors: this.errors };
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var c = _a[_i];
            c(progress);
        }
    };
    return ConcurrencyLimit;
}());
exports.ConcurrencyLimit = ConcurrencyLimit;
// Controls access to a fixed number of resources
var ResourcePool = /** @class */ (function () {
    // This is a pretty shit api.
    function ResourcePool(n, builder, onError) {
        this.queued = new containers_1.DeQueue();
        this.resources = new containers_1.DeQueue();
        this.max = n;
        this.constructed = 0;
        this.builder = builder;
        this.onError = onError;
    }
    ResourcePool.prototype.take = function () {
        var _this = this;
        return new Promise(function (res, rej) {
            _this.queued.pushBack(res);
            _this.process();
        });
    };
    ResourcePool.prototype.release = function (resource) {
        this.resources.pushBack(resource);
        this.process();
    };
    ResourcePool.prototype.run = function (fn) {
        var _this = this;
        return this.take().then(function (r) {
            return fn(r)
                .catch(function (e) {
                _this.release(r);
                return Promise.reject(e);
            })
                .then(function (v) {
                _this.release(r);
                return v;
            });
        });
    };
    ResourcePool.prototype.process = function () {
        var _this = this;
        var _loop_1 = function () {
            this_1.constructed++;
            var queued = this_1.queued.popFront();
            this_1.builder()
                .catch(function (e) {
                // Push `queued` back to the front of the queue.
                _this.queued.pushFront(queued);
                return Promise.reject(e);
            })
                .then(function (r) { return queued(r); })
                .catch(this_1.onError);
        };
        var this_1 = this;
        // Lazily construct the resources.
        while (this.constructed < this.max && this.queued.peekFront() !== undefined) {
            _loop_1();
        }
        // Re-assign the resources that have returned home.
        while (this.resources.peekFront() !== undefined && this.queued.peekFront() !== undefined) {
            this.queued.popFront()(this.resources.popFront());
        }
    };
    return ResourcePool;
}());
exports.ResourcePool = ResourcePool;
function report(output, scheduler, periodMs) {
    if (periodMs === void 0) {
        periodMs = 10000;
    }
    var start = Date.now();
    var periodStart = Date.now();
    var periodCount = 0;
    var lastComplete = 0;
    scheduler.onProgress(function (progress) {
        var deltaComplete = progress.complete - lastComplete;
        lastComplete = progress.complete;
        periodCount += deltaComplete;
        var now = Date.now();
        var elapsed = now - periodStart;
        var rate = (progress.complete * 1000) / (now - start);
        var ETASeconds = (progress.queued - progress.complete) / rate;
        var eta = new Date(Date.now() + ETASeconds * 1000);
        if (elapsed > periodMs || progress.complete === progress.queued) {
            output.debug('Progress ' +
                periodCount +
                ' at ' +
                ((1000 * periodCount) / elapsed).toFixed(1) +
                ' processed ' +
                progress.complete +
                ' of ' +
                progress.queued +
                ' failed ' +
                progress.errors +
                ' Avg Rate ' +
                rate.toFixed(1) +
                ' ETA ' +
                eta.toLocaleString());
            periodStart = now;
            periodCount = 0;
        }
    });
}
exports.report = report;
/* DispatchRateControl allows us to schedule operations producing Promise<R> at a specified rate s.t.
 * - we don't accumulate dispatch rate error over time.
 * - we never dispatch at a rate greater than our configured rate.
 * DispatchRateControl is only concerned with start rate, not the completion rate.
 */
var DispatchRateControl = /** @class */ (function () {
    /**
     * @param dispatchRateHz the maximum rate for dispatching operations from our input queue
     * @param schedulerRateHz the approximate rate we run our scheduler.
     * @param autostart dispatch whenever our input queue is not empty
     * TODO: this probably needs a max concurrency parameter to be useful with http in nodejs.
     */
    function DispatchRateControl(dispatchRateHz, schedulerRateHz, autostart) {
        if (schedulerRateHz === void 0) {
            schedulerRateHz = 100;
        }
        if (autostart === void 0) {
            autostart = false;
        }
        this.queue = new containers_1.DeQueue();
        this.rate = dispatchRateHz;
        this.runFlags = new containers_1.DeQueue();
        this.schedulerDelay = 1000 / schedulerRateHz;
        this.autostart = autostart;
    }
    /* Enqueue an operation `op` to be scheduled by the RateControl
     */
    DispatchRateControl.prototype.enqueue = function (op) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queue.pushBack(function () {
                op().then(resolve, reject);
            });
            if (_this.autostart) {
                _this.start();
            }
        });
    };
    /* Start dispatching operations
     */
    DispatchRateControl.prototype.start = function () {
        if (this.runFlags.empty()) {
            this.stop();
            var flag = { run: true };
            this.runFlags.pushBack(flag);
            this.schedule(flag);
        }
    };
    /* Stop dispatching operations
     */
    DispatchRateControl.prototype.stop = function () {
        while (this.runFlags.peekFront()) {
            this.runFlags.popFront().run = false;
        }
    };
    /* Our main schedule loop. Rate control only applies through
     * a single schedule invocation.
     */
    DispatchRateControl.prototype.schedule = function (flag) {
        var _this = this;
        var runCount = 0;
        var startTime = Date.now();
        var run = function () {
            var now = Date.now();
            // If we are behind our desired rate, dispatch.
            var shouldStart = flag.run && (runCount * 1000) / (now - startTime) < _this.rate;
            if (shouldStart) {
                var fn = _this.queue.popFront();
                if (fn) {
                    runCount++;
                    fn();
                }
            }
            // When our input queue underruns, we have to stop to avoid a rate spike
            // when it is filled again in the future.
            if (_this.queue.empty()) {
                _this.stop();
            }
            if (flag.run) {
                setTimeout(run, _this.schedulerDelay);
            }
        };
        setTimeout(run, this.schedulerDelay);
    };
    return DispatchRateControl;
}());
exports.DispatchRateControl = DispatchRateControl;
/**
 * Given a side-effecting function that produces a value of type C,
 * cache that value for the specified time. Refresh it after that
 * time has elapsed.
 */
var Cache = /** @class */ (function () {
    function Cache(ttlMs, refresh, clock) {
        if (clock === void 0) {
            clock = Date.now;
        }
        this.ttlMs = ttlMs;
        this.refresh = refresh;
        this.clock = clock;
        this.lastRefresh = 0;
        this.content = undefined;
        this.stats = {
            hits: 0,
            misses: 0,
        };
    }
    Cache.prototype.get = function (param) {
        return __awaiter(this, void 0, void 0, function () {
            var now, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        now = this.clock();
                        if (!(now - this.ttlMs > this.lastRefresh || this.content === undefined))
                            return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.refresh(param)];
                    case 1:
                        _a.content = _b.sent();
                        this.lastRefresh = now;
                        this.stats.misses++;
                        return [3 /*break*/, 3];
                    case 2:
                        this.stats.hits++;
                        _b.label = 3;
                    case 3: return [2 /*return*/, this.content];
                }
            });
        });
    };
    Cache.prototype.getStats = function () {
        return __assign({}, this.stats);
    };
    return Cache;
}());
exports.Cache = Cache;
